import { render, staticRenderFns } from "./UserAccountBilling.vue?vue&type=template&id=85dfa472&"
import script from "./UserAccountBilling.vue?vue&type=script&lang=js&"
export * from "./UserAccountBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports